import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { useCallback, useState, useMemo } from "react";
import { CallApiGetVerifyCode } from "../Api/Enforcement";
import { rePass } from "../Api/SubUrl";
import { SwalSuccess } from "../Share/Swal";
import useCookieStorage from "./useCookieStorage";
import {
  FORGET_PASS_USER_ID_KEY,
  FORGET_PASS_EMAIL_KEY,
} from "../Constants/localStorageKey";
import { ShowCustomErrorModal } from "../Components/Atoms/CustomErrorModal";
export default function useClientAccuracy() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setValue } = useCookieStorage();
  const verifySchema = yup.object().shape({
    userName: yup.string().required("Vui lòng nhập tên tài khoản"),
    email: yup
      .string()
      .email("Email không hợp lệ")
      .typeError("Email không hợp lệ")
      .required("Vui lòng nhập email"),
  });

  const { control, handleSubmit, reset } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: useMemo(
      () => ({
        userName: "",
        email: "",
      }),
      []
    ),
    resolver: yupResolver(verifySchema),
  });

  const handleVerify = useCallback(
    async (formData) => {
      if (loading) return;
      setLoading(true);

      CallApiGetVerifyCode(formData, (res) => {
        setLoading(false);
        if (res.Status) {
          const response = res.Status;
          if (response.status === 400)
            ShowCustomErrorModal({
              message: `<p>${response.data.Message}</p>`,
              title: "Cập nhật thất bại",
            });
          else
            ShowCustomErrorModal({
              message:
                "Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ",
              title: "Đã xảy ra lỗi",
            });
        } else {
          if (res !== "success") {
            ShowCustomErrorModal({
              message:
                "Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ",
              title: "Đã xảy ra lỗi",
            });
            return;
          }
          reset();
          setValue(FORGET_PASS_USER_ID_KEY, formData.userName);
          setValue(FORGET_PASS_EMAIL_KEY, formData.email);
          SwalSuccess("Vui lòng kiểm tra email của bạn!");
          navigate(rePass);
        }
      });
    },
    [loading, navigate, reset, setValue]
  );

  const handleInvalid = useCallback((errors) => {
    const errorMessages = Object.values(errors)
      .map((err) => `<p>${err.message}</p>`)
      .join("");
    ShowCustomErrorModal({
      message: errorMessages,
      title: "Đăng nhập thất bại",
    });
  }, []);
  return {
    control,
    handleSubmit: handleSubmit(handleVerify, handleInvalid),
    loading,
  };
}
